export const statusColorCode = {
  1:'#8cb2f2',
  2:'#6dbb71',
  3:'#e8dc61',
  4:'#de8f79'
}

